import axios from 'axios';

// Gets the logged in user data from local session 
const getLoggedInUser = () => {
    const user = localStorage.getItem('user');
    if (user)
        return JSON.parse(user);
    return null;
}

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
}

// Register Method
const postRegister = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status >= 200 || response.status <= 299)
            return response.data;
        throw response.data;
    }).catch(err => {
        var message;
        if (err.response && err.response.status ) {
            switch (err.response.status) {
                case 404: message = "Sorry! the page you are looking for could not be found"; break;
                case 500: message = "Sorry! something went wrong, please contact our support team"; break;
                case 401: message = "Invalid credentials"; break;
                default: message = err[1]; break;
            }
        }
        throw message;
    });

}

// True login
const satelliteLogin = (url, data) => {
    return axios.post(url+'/api/rest-auth/login/?format=json', data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

const satelliteProfile = (url, data) => {
    const config = {
      headers: {
        'Authorization': "Token " + data.token.key
      },
    }

    // multicall HERE?? 
    return axios.get(url+'/api/hr/currentuser/', config).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

const satelliteMemberProfile = (url, data) => {
    const config = {
      headers: {
        'Authorization': "Token " + data.token.key
      },
    }

    // multicall HERE?? 
    return axios.get(url+'/api/hr/current-anetar-data/', config).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// True logout, no Firebase
const satelliteLogout = (url, data) => {
    const config = {
        headers: {
          'Authorization': "Token " + data.key
        },
        timeout: 3000,
    }

    axios.defaults.headers.common['Authorization'] = ''

    return axios.post(url+'/api/rest-auth/logout/?format=json', {}, config).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// Login Method
const postLogin = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// postForgetPwd 
const postForgetPwd = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

export { getLoggedInUser, isUserAuthenticated, postRegister, satelliteLogin, satelliteProfile, satelliteMemberProfile, 
         satelliteLogout, postLogin, postForgetPwd }